import PageLayout from '@/components/feature/PageLayout';
import { backendFeatureRegistry, type BackendFeature } from '@/config/features';

interface FeatureUnavailablePageProps {
  feature: BackendFeature;
  standalone?: boolean;
}

function UnavailableState({ feature }: { feature: BackendFeature }) {
  const definition = backendFeatureRegistry[feature];

  return (
    <section
      className="raised-panel mx-auto max-w-2xl rounded-lg border border-surface-200 p-6 sm:p-8"
      aria-labelledby="feature-unavailable-title"
    >
      <div className="flex flex-col gap-5 sm:flex-row sm:items-start">
        <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-md bg-surface-100 text-surface-500">
          <i className="ri-plug-line text-xl" aria-hidden="true" />
        </span>
        <div>
          <p className="text-[11px] font-semibold uppercase tracking-[0.12em] text-surface-400">
            Backend-режим
          </p>
          <h2
            id="feature-unavailable-title"
            className="mt-2 text-lg font-semibold text-surface-900"
          >
            Сейчас недоступно: {definition.title}
          </h2>
          <p className="mt-2 text-sm leading-6 text-surface-500">{definition.description}</p>
          <p className="mt-4 border-t border-surface-200 pt-4 text-xs leading-5 text-surface-400">
            Демонстрационные данные отключены. Функция появится здесь после интеграции полного
            API-контракта.
          </p>
        </div>
      </div>
    </section>
  );
}

export default function FeatureUnavailablePage({
  feature,
  standalone = false,
}: FeatureUnavailablePageProps) {
  const definition = backendFeatureRegistry[feature];

  if (standalone) {
    return (
      <main className="flex min-h-dvh items-center bg-surface-50 px-4 py-10 sm:px-6">
        <div className="mx-auto w-full max-w-2xl">
          <div className="mb-6 flex items-center justify-center gap-3">
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500 text-white">
              <i className="ri-rocket-line" aria-hidden="true" />
            </span>
            <span className="text-lg font-semibold tracking-[-0.02em] text-surface-900">
              Queries
            </span>
          </div>
          <UnavailableState feature={feature} />
        </div>
      </main>
    );
  }

  return (
    <PageLayout
      title={definition.title}
      description="Доступность функции в текущем источнике данных."
    >
      <UnavailableState feature={feature} />
    </PageLayout>
  );
}
